// removed by extract-text-webpack-plugin
module.exports = {"Product":"src-components-Products----Product-module---Product---38dXf","ContentContainer":"src-components-Products----Product-module---ContentContainer---18NIn","BorderContainer":"src-components-Products----Product-module---BorderContainer---2ZHDl","name":"src-components-Products----Product-module---name---1PDrT","additionalName":"src-components-Products----Product-module---additionalName---1VLyi","brand":"src-components-Products----Product-module---brand---LL33x"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Products/Product.module.css
// module id = 385
// module chunks = 35783957827783